import { useCallback, useState } from "react";
import { getFetch } from "../../hooks/useFetch";
import { IDocument } from "../../interfaces/IDocument";
import { IProjectDocument } from "../../interfaces/IProjectDocument";
import { Box, Dialog, DialogActions, DialogContent, IconButton, TableCell, TableRow, TextField } from "@mui/material";
import { Close, Delete, Download, Edit, Save, Visibility } from "@mui/icons-material";
import { PDFViewer } from "../core/PDFViewer";

interface IProps {
    currentDocument: IProjectDocument;
    handleDelete: Function;
    handleUpdate: Function;
}

export const DocumentRow: React.FC<IProps> = ({ currentDocument, handleDelete, handleUpdate }) => {
    const [documentName, setDocumentName] = useState<string>(currentDocument.Document.file_name);
    const [showPDFView, setShowPDFView] = useState<boolean>(false);
    const [localDocumentObject, setLocalDocumentObject] = useState<IDocument>();
    const [isEditing, setIsEditing] = useState(false);

    const base64Download = useCallback(
        (localDocumentObject: IDocument, download: boolean) => {
            if (localDocumentObject.data !== undefined) {
                setLocalDocumentObject(localDocumentObject);
                if (download === false) {
                    setShowPDFView(true);
                } else {
                    let byteCharacters = atob(localDocumentObject.data);

                    let byteNumbers = new Array(byteCharacters.length);
                    for (let i = 0; i < byteCharacters.length; i++) {
                        byteNumbers[i] = byteCharacters.charCodeAt(i);
                    }

                    let byteArray = new Uint8Array(byteNumbers);

                    let blob = new Blob([byteArray], {
                        type: localDocumentObject.MIMEtype.MIMEtype,
                    });

                    let blobUrl = URL.createObjectURL(blob);
                    let a = document.createElement("a");
                    a.href = blobUrl;
                    a.download = localDocumentObject.file_name;
                    a.click();
                }
            }
        },
        [setShowPDFView, setLocalDocumentObject],
    );
    const downloadDocument = useCallback(
        (id: number, download: boolean) => {
            if (localDocumentObject?.data !== undefined) {
                base64Download(localDocumentObject, download);
            } else {
                getFetch<IDocument>(
                    "/document/",
                    id,
                    (localDocumentObject: IDocument) => {
                        base64Download(localDocumentObject, download);
                    },
                    (succesfull: boolean) => {
                        if (!succesfull) {
                        }
                    },
                );
            }
        },
        [localDocumentObject, base64Download],
    );

    return (
        <>
            <TableRow>
                <TableCell>{currentDocument.id}</TableCell>
                {isEditing && (
                    <TableCell>
                        <TextField value={documentName} onChange={(e) => setDocumentName(e.target.value)} />
                    </TableCell>
                )}
                <TableCell>{currentDocument.Document.file_name}</TableCell>
                <TableCell>
                    {!isEditing && (
                        <>
                            <IconButton
                                title="View"
                                onClick={() => downloadDocument(currentDocument.Document.id!, false)}
                            >
                                <Visibility />
                            </IconButton>
                            <IconButton
                                title="Download"
                                onClick={() => downloadDocument(currentDocument.Document.id!, true)}
                            >
                                <Download />
                            </IconButton>
                            <IconButton title="Bearbeiten" onClick={() => setIsEditing(true)}>
                                <Edit />
                            </IconButton>
                            <IconButton title="Löschen" onClick={() => handleDelete(currentDocument)}>
                                <Delete />
                            </IconButton>
                        </>
                    )}
                    {isEditing && (
                        <>
                            <IconButton title="Speichern" onClick={() => handleUpdate(currentDocument, documentName)}>
                                <Save />
                            </IconButton>
                            <IconButton
                                title="Abbrechen"
                                onClick={() => {
                                    setIsEditing(false);
                                    setDocumentName(currentDocument.Document.file_name);
                                }}
                            >
                                <Close />
                            </IconButton>
                        </>
                    )}
                </TableCell>
            </TableRow>
            {currentDocument.Document !== undefined && (
                <Dialog open={showPDFView} fullScreen onClose={() => setShowPDFView(false)}>
                    <DialogActions>
                        <IconButton onClick={() => setShowPDFView(false)}>
                            <Close />
                        </IconButton>
                    </DialogActions>
                    <DialogContent>
                        {currentDocument.Document.MIMEtype.MIMEtype === "application/pdf" && (
                            <PDFViewer documentObject={localDocumentObject ? localDocumentObject : null}></PDFViewer>
                        )}
                        {currentDocument.Document.MIMEtype.MIMEtype !== "application/pdf" && (
                            <Box
                                component={"img"}
                                src={
                                    `data:` +
                                    currentDocument.Document.MIMEtype.MIMEtype +
                                    `;base64,` +
                                    localDocumentObject?.data
                                }
                            />
                        )}
                    </DialogContent>
                </Dialog>
            )}
        </>
    );
};
